import React from 'react';
import { Theme, makeStyles, createStyles } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            margin: '2rem auto',
            width: '80px',
            height: '80px',
        },
        dot: {
            position: 'absolute',
            width: '6px',
            height: '6px',
            background: '#8dd9c8',
            borderRadius: '50%',
            animation: '$loading 1.2s linear infinite',

            '&:nth-child(1)': {
                animationDelay: '0s',
                top: '37px',
                left: '66px',
            },
            '&:nth-child(2)': {
                animationDelay: '-0.1s',
                top: '22px',
                left: '62px',
            },
            '&:nth-child(3)': {
                animationDelay: '-0.2s',
                top: '11px',
                left: '52px',
            },
            '&:nth-child(4)': {
                animationDelay: '-0.3s',
                top: '7px',
                left: '37px',
            },
            '&:nth-child(5)': {
                animationDelay: '-0.4s',
                top: '11px',
                left: '22px',
            },
            '&:nth-child(6)': {
                animationDelay: '-0.5s',
                top: '22px',
                left: '11px',
            },
            '&:nth-child(7)': {
                animationDelay: '-0.6s',
                top: '37px',
                left: '7px',
            },
            '&:nth-child(8)': {
                animationDelay: '-0.7s',
                top: '52px',
                left: '11px',
            },
            '&:nth-child(9)': {
                animationDelay: '-0.8s',
                top: '62px',
                left: '22px',
            },
            '&:nth-child(10)': {
                animationDelay: '-0.9s',
                top: '66px',
                left: '37px',
            },
            '&:nth-child(11)': {
                animationDelay: '-1.0s',
                top: '62px',
                left: '52px',
            },
            '&:nth-child(12)': {
                animationDelay: '-1.1s',
                top: '52px',
                left: '62px',
            },
        },
        '@keyframes loading': {
            '0%,20%,80%,100%': {
                transform: 'scale(1)',
            },
            '50%': {
                transform: 'scale(1.5)',
            },
        },
    }),
);

const LoadingIndicator = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CircularProgress thickness={4} />
            {/* <div className="k-loading-color"></div> */}
            {/* <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div>
            <div className={classes.dot}></div> */}
        </div>
    );
};

export default LoadingIndicator;
